import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("strong", null, "CAMERAS:", -1)
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "VIDEOS:", -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")!
  const _component_PageContentLayout = _resolveComponent("PageContentLayout")!

  return (_openBlock(), _createBlock(_component_PageContentLayout, null, {
    default: _withCtx(() => [
      _hoisted_1,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cameras, (camera) => {
        return (_openBlock(), _createElementBlock("div", {
          key: camera.id
        }, [
          _createTextVNode(" ID:" + _toDisplayString(camera.id) + " " + _toDisplayString(camera.name) + " | Active:" + _toDisplayString(camera.active) + " | Rec:" + _toDisplayString(camera.stream_settings.enable_recorder) + " ", 1),
          _createElementVNode("button", {
            onClick: ($event: any) => (_ctx.play('cameras', camera.id))
          }, "play", 8, _hoisted_2),
          _hoisted_3
        ]))
      }), 128)),
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video) => {
        return (_openBlock(), _createElementBlock("div", {
          key: video.id
        }, [
          _createTextVNode(" ID:" + _toDisplayString(video.id) + " " + _toDisplayString(video.name) + " | Active:" + _toDisplayString(video.active) + " | Status:" + _toDisplayString(video.health_status.status) + " ", 1),
          _createElementVNode("button", {
            onClick: ($event: any) => (_ctx.play('videos', video.id))
          }, "play", 8, _hoisted_5),
          _hoisted_6
        ]))
      }), 128)),
      (`${_ctx.playModel}${_ctx.playId}`)
        ? (_openBlock(), _createBlock(_component_VideoPlayer, {
            key: `${_ctx.playModel}${_ctx.playId}`,
            model: _ctx.playModel,
            cameraId: _ctx.playId
          }, null, 8, ["model", "cameraId"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}